module.exports = __webpack_public_path__ + "static/media/open-modal.9eed573a.wav";